import React from 'react';
import { isStringNullOrEmpty } from '../../../../helpers/validators';
import { InputText } from '../../../../components/tools/BootstrapControls';
import { AsteriskRed } from '../../../../components/tools/Others';
import * as apiCaller from '../../../../helpers/apiCaller'
import serviceUrls from '../../../../constants/serviceUrls';
import uiHelpers from '../../../../helpers/uiHelpers';
import { convertMeterStatus } from '../../../../helpers/converters';

class MeterAdminDecommission  extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            confirming:false
            , submitting:false
            , succeeded:null
            , comments:''
            , commentsError:null
        };
    }

    onExecuteClick = () => {
        if(isStringNullOrEmpty(this.state.comments)) {
            this.setState({commentsError:'This is required'})
        } else {
            this.setState({commentsError:null, confirming:true});
        }
        
    }

    onCancelClick = () => {this.setState({confirming:false});}

    onConfirmClick = async () => {
        
        uiHelpers.showProgressOnTop('Decommissioning meter...');
        this.setState({submitting:true})
        await apiCaller.post(serviceUrls.admin.decommissionMeter,{id:this.props.meter.id, comments:this.state.comments})
        .then(async data=>{
            await this.props.refresh();
            this.setState({succeeded:data.succeed, submitting:false});
        }).finally(()=>{
            uiHelpers.hideProgressOnTop();
        })
        ;
    }

    renderWhatWillHappen = () => {
        return <div>
            <p>Please note the following changes will be done in this decommissioning process:</p>
            <div className='text-start row'>
                <div className='col-md-3'></div>
                <div className='col-md-6'>
                    <ul>
                        <li>The meter record created in this process (if any) within DQP Portal will be decommissioned. (Status will be updated to "{convertMeterStatus("DECOMMISSIONED")}").</li>
                        <li>The workspace created in this process (if any) within DAS <b className='text-primary'>WILL ALSO</b> be deactivated.</li>
                    </ul>
                </div>
                <div className='col-md-3'></div>
            </div>
        </div>
    }

    renderMainFunction = () => {
        return <>

            <div className='row mb-3'>
                <div className='col-md-4'>
                    Comments <AsteriskRed/>
                </div>
                <div className='col-md-8'>
                    <InputText
                        value={this.state.comments} 
                        error={this.state.commentsError} 
                        disabled={this.state.confirming || this.state.succeeded != null}
                        onChange={(e)=>this.setState({comments:e.target.value})} 
                    /> 
                </div>
            </div>

            {!this.state.confirming && this.state.succeeded===null && <>
                
                <div className='row mb-3'>
                    <div className='col-md-4'/>
                    <div className='col-md-8'>
                        <button className='btn btn-primary' onClick={this.onExecuteClick}>Proceed</button>
                    </div>
                </div>
            </>}

            {this.state.confirming && this.state.succeeded===null && <div className='card border-danger border-1 mb-3'>
                <div className='card-body bg-danger bg-opacity-10 text-center'>
                    <p className='text-primary'>
                        <b>Please confirm that you would like to proceed with the decommission of this meter.</b>
                    </p>
                    {this.renderWhatWillHappen()}
                    <div>
                        <button type="button" class="btn btn-secondary me-3" onClick={this.onCancelClick} disabled={this.state.submitting}>
                            Cancel
                        </button>
                        <button type="button" class="btn btn-primary" onClick={this.onConfirmClick} disabled={this.state.submitting} >
                            Confirm
                        </button>
                    </div>
                </div>
            </div>}

            {this.state.succeeded===true && <div className='card border-success border-1 mb-3'>
                <div className='card-body bg-success bg-opacity-10 text-center text-success'>
                    <b>This meter has been decommissioned.</b>
                </div>
            </div>}

            {this.state.succeeded===false && <div className='card border-danger border-1 mb-3'>
                <div className='card-body bg-danger bg-opacity-10 text-center text-danger'>
                    <b>System failed to decommission this meter. Please check audit for more information.</b>
                </div>
            </div>}

        </>
    }

    render() {
        if(this.state.succeeded===null && this.props.meter.status!='ACTIVE') return <div className='alert alert-danger mt-4'>
            This meter cannot be decommissioned under the current status. Only <b>Active</b> meter can be decommissioned using this function.
        </div>;
        return this.renderMainFunction();
    }
}

export default MeterAdminDecommission;
